import { createApi } from '@reduxjs/toolkit/query/react';

import { amplifyBaseQuery } from '../api/apiBaseQuery';

let rootApiBaseUrl = '';

switch (window.REACT_APP_NODE_ENV) {
    case 'production':
        rootApiBaseUrl = ' https://api.helloself.com';
        break;
    case 'staging':
        rootApiBaseUrl = 'https://api.test-helloself.com';
        break;
    case 'local':
    default:
        // assume dev
        rootApiBaseUrl = 'https://api.dev-helloself.com';
        break;
}

// Define a service using a base URL and expected endpoints
export const rootApi = createApi({
    reducerPath: 'rootApi',
    baseQuery: amplifyBaseQuery({ baseUrl: rootApiBaseUrl }),
    endpoints: () => ({}),
    tagTypes: [
        'Referral',
        'Referrals',
        'Profile',
        'Profiles',
        'ProfilePhoto',
        'ProfileInsurers',
        'ProfileSpecialisms',
        'ProfileTreatmentApproaches',
        'Connections',
        'ReferralTopics',
        'Partner',
    ],
});
